import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../lib/auth";
import Header from "../components/Header";
import Logo from "../components/Logo";
import { CheckCircle, XCircle, Loader2, ArrowRight } from "lucide-react";

export default function VerifyEmail() {
  const { token } = useParams();
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState("loading"); // loading | success | error
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        await api.post(`/auth/verify-email/${token}`);
        await refresh();
        setState("success");
        setTimeout(() => nav("/dashboard/billing"), 2500);
      } catch (e) {
        setError(formatApiError(e.response?.data?.detail) || "Erreur");
        setState("error");
      }
    })();
  }, [token, nav, refresh]);

  return (
    <div data-testid="verify-email-page" className="min-h-screen text-[#F5F0EB]">
      <Header />
      <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16">
        <div className="w-full max-w-md text-center">
          <div className="flex justify-center mb-8"><Logo size={64} variant="mark" /></div>
          {state === "loading" && (
            <>
              <Loader2 className="mx-auto text-[#C5A059] animate-spin" size={40} />
              <h1 className="font-serif text-3xl font-light mt-6">Vérification en cours...</h1>
            </>
          )}
          {state === "success" && (
            <div data-testid="verify-success">
              <CheckCircle className="mx-auto text-[#C5A059]" size={48} />
              <div className="overline mt-6 mb-3">Adresse confirmée</div>
              <h1 className="font-serif text-4xl font-light mb-3">Votre courriel est vérifié</h1>
              <p className="text-[#A8A39D] text-sm">Redirection vers le choix d'abonnement...</p>
              <Link to="/dashboard/billing" className="btn-gold mt-8 inline-flex">Choisir mon abonnement <ArrowRight size={14} /></Link>
            </div>
          )}
          {state === "error" && (
            <div data-testid="verify-error">
              <XCircle className="mx-auto text-red-400" size={48} />
              <h1 className="font-serif text-3xl font-light mt-6 mb-3">Lien invalide</h1>
              <p className="text-[#A8A39D] text-sm mb-8">{error}</p>
              <Link to="/login" className="btn-ghost inline-flex">Se connecter</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
